import {
	BlastDataPatchDto,
	BlastDataSnapshotDto,
} from "../../../types/blastDtos";
import { getBlastV2, isMockMode, simulateDelay } from "../../api";

export interface GetBlastDataResponse {
	patches: BlastDataPatchDto[];
	snapshot: BlastDataSnapshotDto & { blobData: ArrayBuffer };
}

export const getBlastData = (
	{
		blastId,
		fromUpdateCount = 0,
		shareLinkId,
	}: {
		blastId: string;
		fromUpdateCount?: number;
		shareLinkId?: string;
	},
	isAnon = false as boolean
): Promise<GetBlastDataResponse> => {
	if (isMockMode()) {
		const testData = {
			patches: [
				{
					blastId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					updatedUtc: "2024-10-16T06:17:14.266Z",
					updateCount: 0,
					updatedByUserId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					expectedPreStateHash: {},
					stateHash: {},
					blobDataAccessToken: "",
					sizeInBytes: 0,
					appliesToUpdate: 0,
				},
			],
			snapshot: {
				blastId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				updatedUtc: "2024-10-16T06:17:14.266Z",
				updateCount: 0,
				blobDataAccessToken: "",
				blobData: new ArrayBuffer(0),
				sizeInBytes: 0,
				stateHash: {},
			},
			metadata: {
				id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				name: "string",
				siteId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				createdDateUtc: "2024-10-16T06:17:14.266Z",
				createdBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				metadataLastUpdatedUtc: "2024-10-16T06:17:14.266Z",
				metadataLastUpdatedBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				isPublished: true,
				isDeleted: true,
				dataLastUpdatedUtc: "2024-10-16T06:17:14.266Z",
				dataLastUpdatedBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				updateCount: 0,
				stateHash: {},
				sizeInBytes: 0,
			},
			isPatches: true,
			isSnapshot: true,
		};
		return simulateDelay(50, () => testData);
	}

	const endpoint = isAnon
		? `blasts/getdata-anon-handshake?blastId=${blastId}&fromUpdateCount=${fromUpdateCount}&shareLinkId=${shareLinkId || ""}`
		: `blasts/getdata-handshake?blastId=${blastId}&fromUpdateCount=${fromUpdateCount}&shareLinkId=${shareLinkId || ""}`;

	return (async () => {
		const handshake = await getBlastV2(endpoint);
		const blobData: ArrayBuffer = await fetch(
			handshake.snapshot.blobDataAccessToken
		).then((r) => r.arrayBuffer());
		return { ...handshake, snapshot: { ...handshake.snapshot, blobData } };
	})();
};
